import React from 'react';
import Icon from 'lqa-ui/lib/Components/Icon';
import styled from 'styled-components';
import DetailCardComponent from './DetailCardComponent';

const Card = styled('div')`
  border-radius: 0.25rem;
  border: 1px solid #4fada6;
  background: var(--white, #fff);
  box-shadow:
    0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13),
    0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.1);
  padding: 15px 18px;
  margin-top: 16px;

  & h3 {
    color: #071c3e;
    font-feature-settings:
      'clig' off,
      'liga' off;
    font-family: Source Sans Pro;
    font-size: 1.25rem;
    font-style: italic;
    font-weight: 600;
    line-height: 1.5rem;
  }
  & .right-card {
    flex-direction: column;
  }
  & .currentJobTitle {
    color: #071c3e;
    text-align: right;
    /* Source/Body 15/Semibold */
    font-family: Source Sans Pro;
    font-size: 0.9375rem;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
  }
  .experience {
    color: #919191;
    text-align: right;
    /* Source/Caption 12/Semibold */
    font-family: Source Sans Pro;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
  }
  .location {
    color: #4fada6;
    text-align: right;
    /* Source/Caption 12/Regular */
    font-family: Source Sans Pro;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1rem; /* 133.333% */
  }
  & .justify-content-between {
    justify-content: space-between;
  }
  & .check {
    color: #4fada6;
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 15px;
  }
`;

const HotelCard = ({ hotelData, hotelEntries }) => {
  const formatDate = (date) => {
    // Create a Date object from the input string
    const inputDate = new Date(date);

    // Get the year and month from the Date object
    const year = inputDate.getFullYear();
    const month = inputDate.toLocaleString('en-US', { month: 'long' });

    // Create the formatted date string
    const formattedDate = `${month} - ${year}`;

    // Output the formatted date
    return formattedDate;
  };

  const [isDetailViewOpen, setIsDetailViewOpen] = React.useState(false);

  return isDetailViewOpen ? (
    <div className="mt-20 mb-20">
      <DetailCardComponent
        setIsDetailViewOpen={setIsDetailViewOpen}
        hotelData={hotelData}
        hotelEntries={hotelEntries}
        formatDate={formatDate}
      />
    </div>
  ) : (
    <Card onClick={() => setIsDetailViewOpen(true)}>
      <div className="d-flex justify-content-between">
        <h3 className="name">{hotelData.hotelName}</h3>
        <div className="right-card">
          <div className="currentJobTitle">{hotelData.currentJobTitle}</div>
          <div className="experience">
            {formatDate(hotelData.startDate)} -{' '}
            {hotelData.endDate ? formatDate(hotelData.endDate) : 'Present'}
          </div>
          <div className="location">
            {[hotelData.city, hotelData.state, hotelData.country]
              .filter(Boolean)
              .join(', ')}
          </div>
        </div>
      </div>
      {hotelData.isVerified ? (
        <div className="check">
          <Icon
            kind="tick-points"
            style={{ fill: '#4FADA6' }}
            height={20}
            width={20}
          />
          Verified LQA
        </div>
      ) : null}
    </Card>
  );
};

const CardComponent = ({ hotelsData }) => {
  return (
    <>
      {!!Object.keys(hotelsData).length
        ? Object.keys(hotelsData).map((hotelName, index) => {
            const hotelData = hotelsData[hotelName][0];

            return (
              // tslint:disable-next-line:jsx-key
              <HotelCard
                hotelData={hotelData}
                hotelEntries={hotelsData[hotelName]}
              />
            );
          })
        : null}
    </>
  );
};

export default CardComponent;
